import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import AttributeDef, { AttributeType } from 'models/configuration/attribute_def';
import CustomAttributeBase from './custom_attribute_base';
import { getPercentAttrAsNumber } from '../lib/custom_attributes_helper';
import PercentCustomAttributeGraphic from './percent_custom_attribute_graphic';

const VisiblePercentCustomAttributeBase = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const VisiblePercentCustomAttributePercentage = styled.div`
  flex-basis: 25%;
`;

const VisiblePercentCustomAttributePercentBar = styled.div`
  flex-basis: 75%;
  padding-left: 10px;
`;

export default function VisiblePercentCustomAttribute({ className, def, value, renderProps }) {
  if (!value || def.type !== AttributeType.PERCENT) {
    return null;
  }

  let renderGraphic = null;
  const valAsNumber = getPercentAttrAsNumber(value);
  if (renderPropsHasHighWaterMark(renderProps) && valAsNumber && !Number.isNaN(valAsNumber)) {
    renderGraphic = <PercentCustomAttributeGraphic value={valAsNumber} highWaterMark={renderProps.highWaterMark} />;
  }

  return (
    <CustomAttributeBase className={className} label={def.label}>
      <VisiblePercentCustomAttributeBase>
        <VisiblePercentCustomAttributePercentage>{value}</VisiblePercentCustomAttributePercentage>
        <VisiblePercentCustomAttributePercentBar>{renderGraphic}</VisiblePercentCustomAttributePercentBar>
      </VisiblePercentCustomAttributeBase>
    </CustomAttributeBase>
  );
}

function renderPropsHasHighWaterMark(renderProps) {
  return renderProps && renderProps.hasOwnProperty('highWaterMark') && !isNaN(renderProps.highWaterMark);
}

VisiblePercentCustomAttribute.propTypes = {
  className: PropTypes.string,
  def: PropTypes.instanceOf(AttributeDef).isRequired,
  value: PropTypes.any,
  renderProps: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attributes/visible_percent_custom_attribute.jsx